module.exports = __webpack_public_path__ + "img/8提交作业.7056ac8b.gif";